import Vue from 'vue';
export const LeftArrowIcon = Vue.extend({
    functional: true,
    name: 'LeftArrowIcon',
    render(createElement, ctx) {
        return (<svg viewBox="0 0 50 50">
                <path d="M36.8 25.666666H15.866667L24.2 34l-1 1-10-10 10-10 1 .983333-8.333333 8.333333H36.8z" style="fill:#f2f3f4;stroke-width:1.66666663"/>
            </svg>);
    },
});
//# sourceMappingURL=LeftArrowIcon.jsx.map